<app-preloader *ngIf="isLoading"></app-preloader>
<div class="extractMobile collapsed" [id]="'deal' + indexDeal">
  <!--!isInsuranceEdition  -->
  <div class="title" *ngIf="!modeEdition">
    <div class="name">
      <label class="checkboxWrapper" [for]="indexDeal + 'deal'">
        <input
          type="checkbox"
          [id]="indexDeal + 'deal'"
          [(ngModel)]="deal.isSelected"
          [disabled]="!deal.payments || !deal.payments.length || userId != authService.currentUserIds || readOnlyActions"
          (click)="isSelected.emit($event)"
        />
        <span class="checkmark"></span>
        <span class="description">{{ deal.dealName }}</span>
      </label>
      @if (showDealLoyaltyBadge(deal)) {
      <span class="loyaltyBadge" tp="Propuesta Loyalty"
        ><img src="./assets/images/icons/loyalty.svg" alt="Ícono loyalty"
      /></span>
      }
    </div>
    @if(userId == authService.currentUserIds && !readOnlyActions){
    <div class="contextualMenuMobile" [ngClass]="{ active: !!menuRef() }">
      <a
        (click)="toggleMenuOptions($event, deal.id)"
        class="toggle"
        [id]="getId()"
        aria-haspopup="menu"
        aria-controls="menu-id"
        role="button"
        [attr.aria-expanded]="menuRef()"
      >
        Ver/Ocultar menu
      </a>
      <div
        appBackdropOverlay
        appOutSideClick
        [isActive]="!!menuRef()"
        [ignoreElements]="[getId()]"
        [activeTarget]="menuRef()"
        [currentTarget]="deal.id"
        (outSideClick)="closeMenuOptions()"
        style="z-index: 40"
        class="menuContent"
        role="menu"
        id="menu-id"
        aria-labelledby="menu-button"
      >
        <ul>
          <li role="menuitem">
            <a (click)="edit.emit(indexDeal)" class="iconAndText edit" tabindex="0">Editar</a>
          </li>

          <li role="menuitem">
            <a (click)="duplicate.emit(deal)" class="iconAndText duplicate" tabindex="0">Duplicar</a>
          </li>
          <li role="menuitem">
            <a (click)="delete.emit(indexDeal)" class="iconAndText delete" tabindex="0">Eliminar</a>
          </li>
          @if(canAddInsurance() && !hasMarshInsurance){
          <li role="menuitem">
            <a (click)="addInsurance()" class="iconAndText insurance" tabindex="0"><span></span>Agregar seguro</a>
          </li>
          }
        </ul>
      </div>
    </div>
    }
    <!-- Acciones originales -->
    <!-- <div class="actions" *ngIf="userId == authService.currentUserIds">
        <a (click)="edit.emit(indexDeal)" class="edit" tp="Editar propuesta"
          >Editar</a
        >

        <a
          (click)="duplicate.emit(deal)"
          class="duplicate"
          tp="Duplicar propuesta"
          >Duplicar</a
        >

        <a
          (click)="delete.emit(indexDeal)"
          class="delete"
          tp="Eliminar propuesta"
          >Eliminar</a
        >

        <a (click)="addInsurance()" class="insurance" *ngIf="canAddInsurance()"
          ><span></span>Agregar seguro</a
        >
      </div> -->
  </div>
  <div class="wrapper-duplicate" *ngIf="!deal.result">
    <span class="description">Es necesario recalcular</span>
  </div>
  <div class="wrapper-duplicate" *ngIf="hasMarshInsuranceNotCalculated">
    <span class="description">Es necesario recalcular el seguro</span>
  </div>
  <div class="diroAndRorac">
    <div class="diro">DIRO</div>
    <div class="rorac">
      <div *ngIf="deal.roRac">
        <label>RoRAC</label>
        <span>{{ deal.roRac }}%</span>
      </div>
    </div>
    <div class="identification">
      <label>Quote ID</label>
      <a [href]="quoteUrl(deal)" target="_blank">
        {{ deal.profitDeal?.idQuote ? deal.profitDeal?.idQuote : ' -' }}
      </a>
    </div>
    <div class="identification">
      <label>Deal ID</label>
      <a [href]="dealUrl(deal)" target="_blank">
        {{ deal.profitDeal?.idDeal ? deal.profitDeal?.idDeal : ' -' }}
      </a>
    </div>
  </div>

  <div class="resume" *ngIf="!modeEdition">
    <div class="row">
      <div>
        <label>Producto Financiero</label>
        <span>{{ financialCalculator.getFinancialProduct(deal.financialProductType) }}</span>
      </div>
      <div class="group">
        <div>
          <label>Moneda</label>
          <span>{{ deal.currencyType }}</span>
        </div>
        <div>
          <label>Plazo</label>
          <span>{{ deal.term }}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div>
        <label>Tipo de producto</label>
        <span>{{ financialCalculator.getProductType(deal.productType) }}</span>
      </div>
      <div class="group">
        <div>
          <label>Condición</label>
          <span>{{
            financialCalculator.getClassificationType(deal.classification)
              ? financialCalculator.getClassificationType(deal.classification)
              : 'No Aplica'
          }}</span>
        </div>
        <div>
          <label>Unidades</label>
          <span>{{ deal.quantity }}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div>
        <span>{{ getDisaplayPrice(deal) }}</span>
        <span>{{ getPrice(deal) | currency : "" : ""  }} </span>
      </div>
      <div>
        <label>Enganche</label>
        @if (deal.financialProductType == 'PURE_LEASING'){
        <span>No Aplica</span>
        } @else {
        <span>{{ deal.downPayment | currency : '' : '' }}</span>
        }
      </div>
    </div>
    <div class="row">
      <div>
        <label>Total</label>
        <span>{{ getTotalPrice(deal) | currency : "" : "" }}</span>
      </div>
      @if (insuranceAmount != 0) {
        <div>
          <span>Seguro del vehículo</span>
          <span>{{ insuranceAmount | currency : '' : '' }}</span>
        </div>
        }
    </div>

    <!-- Hacer clic en a.accordionControl hay que agregar o quitar la clase "collapsed" en el div.extract -->
    <a class="accordionControl" (click)="viewDeal(indexDeal)"></a>
  </div>
  <div class="accordionWrapper">
    <div>
      <app-deal-view-mobile [deal]="deal" [isManualInsurance]="false" [nameCompany]="nameCompany" />
    </div>
  </div>
  <div *ngFor="let insurance of insuranceList; let i = index">
    <app-header-insurance-mobile
      [modeEditionProposal]="modeEdition"
      [deal]="insurance"
      [add]="add"
      [form]="insurance"
      [index]="i"
      [idQuote]="idQuote"
      [nameCompany]="nameCompany"
      [userId]="userId"
      [indexDeal]="indexDeal"
      (delete)="deleteSeguro($event)"
      (update)="update($event)"
      (isSelectedInsurance)="selectedInsurance($event)"
      [isEnabled]="deal.isSelected"
      [readOnlyActions]="readOnlyActions"
    ></app-header-insurance-mobile>
  </div>
</div>
